module.exports = __webpack_public_path__ + "img/cc3.202ba726.jpg";